import { render, staticRenderFns } from "./Particularite.vue?vue&type=template&id=688a3562&"
import script from "./Particularite.vue?vue&type=script&lang=js&"
export * from "./Particularite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports